var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.items)?_c('base-editor',{attrs:{"url":_vm.url,"type":"lua","scripts":_vm.items,"selected-script":_vm.selectedScript}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }